import { render, staticRenderFns } from "./specialized-new-footer.vue?vue&type=template&id=0d9b55ca&scoped=true"
import script from "./specialized-new-footer.vue?vue&type=script&lang=js"
export * from "./specialized-new-footer.vue?vue&type=script&lang=js"
import style0 from "./specialized-new-footer.vue?vue&type=style&index=0&id=0d9b55ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9b55ca",
  null
  
)

export default component.exports